import { useQuery } from '@tanstack/react-query';
import { getQuestionnaire } from '../../../../apis/questionnaires/requests';
import { createEmptyQuestionnaire } from './utils';

export const useQuestionnaire = (questionnaireId: string) => {
  const isNewQuestionnaire = questionnaireId === 'create';

  const { data: questionnaire, isLoading, refetch } = useQuery({
    queryKey: ['questionnaire', questionnaireId],
    queryFn: () => {
      if (isNewQuestionnaire) return Promise.resolve(createEmptyQuestionnaire());

      return getQuestionnaire(questionnaireId);
    }
  });

  return { questionnaire, isLoading, refetch };
};
